import React from 'react';
import Section from "./components/Section";
import {lightGradient} from "./Helpers";
import {IMAGES_DIR, LG_BREAKPOINT, resume_download_link} from "../../../Constants/Constants";
import posed from "react-pose";
// import { PDFDownloadLink, Document, Page } from '@react-pdf/renderer'
// import Paper from '../../my-resume/Paper';
// const MyDoc = (props) => (
//   <Document>
//     <Page>
//       <Paper window_width={props.window_width} window_height={props.window_height}/>
//     </Page>
//   </Document>
// );

// const ResumePdf = (props) => (
//   <div>
//     <PDFDownloadLink document={<MyDoc window_width={props.window_width} window_height={props.window_height}/>} fileName="somename.pdf">
//       {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
//     </PDFDownloadLink>
//   </div>
// )
class About extends Section {

	constructor(props) {
		super(props);
		//console.log("About Constructor", props);
		this.aboutRef = React.createRef();
		this.state = {
			aboutMe: "I am a Computer Science Engineering graduate from University School of ICT, GGS Indraprastha University, New Delhi.\n" +
				"I am passionate about coding and love to develop quality apps. My favourite programming languages are Javascript and C++.\n" +
				"My hobbies include reading books and listening to music.\n" +
				"Also, I love F.R.I.E.N.D.S and Game of Thrones."
		}
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.aboutRef);
	}

	styles = {
		...Section.styles,
		mainContainer: {
			...Section.styles.mainContainer,
			// background: "url(" + IMAGES_DIR + "/home.jpg)",
			// backgroundSize: "cover",
			backgroundImage: (this.props.backgroundColor ? lightGradient(this.props.backgroundColor) : "#fff"),
			backgroundAttachment: 'fixed',
			// padding: "10vmin 10vmin 0 10vmin",
		},
		contentContainer: {
			...Section.styles.contentContainer,
			padding: "auto",
			minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			// alignContent: "center",
			justifyContent: "flex-start",
			alignItems: "center",
			// fontSize: "4.5vmin",
			// lineHeight: "6.5vmin"
		},
		title: {
			...Section.styles.title,
			fontStyle: "bold",
		},
		subTitle: {
			...Section.styles.subTitle,
			maxWidth: "90%",
			color: "#ffc107",
			padding: "0.2rem",
			// backgroundColor: "rgba(0,0,0,0.8)"
		},
	};

	render() {
		return (
			<div style={this.styles.mainContainer} ref={this.aboutRef}>
				<div style={this.styles.contentContainer}>
					<h1 style={this.styles.title}>{this.props.title}</h1>
					{this.props.subtitle ? <h2 style={this.styles.subTitle}>{this.props.subtitle}</h2> : null}
					<div style={this.props.window_width >= LG_BREAKPOINT ?
						{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"} :
						{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
						<img alt="Avatar" src={IMAGES_DIR + "/avatar.jpg"}
								 style={{
									 alignSelf: "center",
									 margin: "1rem",
									 height: "30vmin",
									 width: "30vmin",
									 border: "5px solid white",
									 borderRadius: "10rem"
								 }}/>
						<div style={{padding: "1rem"}}>
							<div>
								{
									this.state.aboutMe.split("\n").map((item, index) => <p key={index}>{item}</p>)
								}
							</div>
						</div>
					</div>


					{/* <div style={{display: 'flex', justifyContent: 'center', marginBottom: "2rem"}}>
						<ScaleUpOnHover>
						<a
							className="text-decoration-none text-dark btn btn-light btn-outline-success btn-lg bold"  
							href={resume_download_link}
						>	
							<span className="fa fa-download m-1"></span>{"Download My Resume"}
						</a>
						{/* <div className="text-decoration-none text-dark btn btn-outline-success btn-lg bold">
							<ResumePdf window_width={this.props.window_width} window_height={this.props.window_height}/>
						</div> */}
						{/* </ScaleUpOnHover>
					</div> */}


				</div>
			</div>
		);
	}
}

const ScaleUpOnHover = posed.div({
	hoverable: true,
	init: {scale: 1},
	hover: {scale: 1.1},
	pressable: true,
	press: { scale: 0.9 }
});
export default About;